import React from "react";
import {
  FaCalendarAlt,
  FaEye,
  FaMapMarkerAlt,
  FaShareAlt,
  FaTrash,
} from "react-icons/fa";

import {
  formatDateFr,
  getEventCategory,
  getEventLevel,
  getEventLocation,
  getEventStatusLabel,
  getEventStatusStyle,
  getEventTitle,
  getEventType,
  getEventTypeStyle,
  isEventShared,
} from "../utils/adminEventsUtils";

function EventsTable({ events = [], onOpen, onDelete }) {
  return (
    <section className="hidden overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20 lg:block">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[1180px] text-left">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-400 dark:border-white/10 dark:bg-white/[0.03]">
              <th className="px-4 py-3">Événement</th>
              <th className="px-4 py-3">Date</th>
              <th className="px-4 py-3">Type</th>
              <th className="px-4 py-3">Niveau</th>
              <th className="px-4 py-3">Catégorie</th>
              <th className="px-4 py-3">Lieu</th>
              <th className="px-4 py-3">Statut</th>
              <th className="px-4 py-3 text-right">Actions</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100 dark:divide-white/10">
            {events.map((event) => {
              const shared = isEventShared(event);

              return (
                <tr
                  key={event.id}
                  className="text-sm transition hover:bg-sky-50/60 dark:hover:bg-white/[0.03]"
                >
                  <td className="px-4 py-3">
                    <div className="flex min-w-[260px] items-center gap-3">
                      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-700 to-sky-600 text-white shadow-lg shadow-slate-200 dark:shadow-black/30">
                        <FaCalendarAlt />
                      </div>

                      <div className="min-w-0">
                        <p className="truncate font-bold text-slate-950 dark:text-white">
                          {getEventTitle(event)}
                        </p>

                        <div className="mt-1 flex flex-wrap gap-2">
                          <span className="text-xs font-semibold text-slate-400">
                            ID #{event.id}
                          </span>

                          {shared && (
                            <span className="inline-flex items-center gap-1 text-xs font-bold text-indigo-600 dark:text-indigo-300">
                              <FaShareAlt />
                              Partagé
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </td>

                  <td className="px-4 py-3">
                    <p className="font-bold text-slate-700 dark:text-white/80">
                      {formatDateFr(event.start)}
                    </p>
                  </td>

                  <td className="px-4 py-3">
                    <span
                      className={`inline-flex min-h-8 items-center rounded-2xl px-3 text-xs font-bold ${getEventTypeStyle(
                        event,
                      )}`}
                    >
                      {getEventType(event)}
                    </span>
                  </td>

                  <td className="px-4 py-3">
                    <p className="max-w-[180px] truncate text-xs font-bold text-slate-500 dark:text-white/50">
                      {getEventLevel(event)}
                    </p>
                  </td>

                  <td className="px-4 py-3">
                    <p className="max-w-[180px] truncate text-xs font-bold text-slate-500 dark:text-white/50">
                      {getEventCategory(event)}
                    </p>
                  </td>

                  <td className="px-4 py-3">
                    <p className="flex max-w-[240px] items-center gap-2 truncate text-xs font-bold text-slate-500 dark:text-white/50">
                      <FaMapMarkerAlt className="shrink-0 text-slate-300" />
                      {getEventLocation(event)}
                    </p>
                  </td>

                  <td className="px-4 py-3">
                    <span
                      className={`inline-flex min-h-8 items-center rounded-2xl px-3 text-xs font-bold ${getEventStatusStyle(
                        event,
                      )}`}
                    >
                      {getEventStatusLabel(event)}
                    </span>
                  </td>

                  <td className="px-4 py-3 text-right">
                    <div className="flex justify-end gap-2">
                      <button
                        type="button"
                        onClick={() => onOpen(event)}
                        className="inline-flex min-h-10 items-center justify-center gap-2 rounded-2xl bg-blue-700 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 hover:bg-blue-800"
                      >
                        <FaEye />
                        Détails
                      </button>

                      <button
                        type="button"
                        onClick={() => onDelete(event.id)}
                        className="inline-flex min-h-10 items-center justify-center gap-2 rounded-2xl border border-red-200 bg-red-50 px-4 py-2 text-xs font-bold text-red-700 transition hover:-translate-y-0.5 hover:bg-red-100 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-200"
                      >
                        <FaTrash />
                        Supprimer
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default EventsTable;